import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import CustomFieldsEditor from './CustomFieldsEditor';

export default class CustomFieldsEditorModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.values = { ...(this.attrs.discussion.customFieldValues() || {}) };
    this.dirty = false;
    this.processing = false;
  }

  title() {
    return app.translator.trans(
      'butterflycode-custom-fields.forum.edit_fields_button'
    );
  }

  content() {
    const definitions = app.forum.attribute('customFieldDefinitions') || [];

    return (
      <div>
        <div className="Modal-body">
          <CustomFieldsEditor
            definitions={definitions}
            values={this.values}
            onchange={(values) => {
              this.values = values;
              this.dirty = true;
            }}
          />
        </div>
        <div className="Modal-footer">
          <Button
            className="Button Button--primary"
            loading={this.processing}
            disabled={!this.dirty}
            onclick={this.save.bind(this)}
          >
            {app.translator.trans('core.forum.composer_edit.submit_button')}
          </Button>
        </div>
      </div>
    );
  }

  save() {
    this.processing = true;

    this.attrs.discussion
      .save({ customFieldValues: this.values })
      .then(() => {
        this.processing = false;
        app.modal.close();
        m.redraw();
      })
      .catch((err) => {
        this.processing = false;
        this.alertAttrs = err.alert;
        m.redraw();
      });
  }
}
